import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { UserAvatarGroupComponent } from './user-avatar-group.component'
import { AvatarModule } from 'primeng/avatar'
import { AvatarGroupModule } from 'primeng/avatargroup'
import { BadgeModule } from 'primeng/badge'
import { OverlayPanelModule } from 'primeng/overlaypanel'
import { ListItemModule } from '@stantec/basin/list-item'
import { DataViewModule } from 'primeng/dataview'

@NgModule({
  declarations: [UserAvatarGroupComponent],
  imports: [
    CommonModule,
    AvatarModule,
    AvatarGroupModule,
    BadgeModule,
    OverlayPanelModule,
    DataViewModule,
    ListItemModule,
  ],
  exports: [UserAvatarGroupComponent],
})
export class UserAvatarGroupModule {}
